export default class ConstraintResource {
    constructor(resource = null, name = null) {
        this.data = resource?.data ?? {};
        this.meta = resource?.meta ?? {};
        this.relations = resource?.relations ?? {};
        this.name = name;

        if(Array.isArray(this.relations) && (this.relations.length < 1)) {
            this.relations = {};
        }

        this.initialize();
    }

    initialize() {
        this.__casts();
        this.__digestRelationMap();
    }

    __digestRelationMap() {
        _.forEach(Object.keys(this.relationsMap), (key) => {
            if(this.relations[key]) {
                switch(typeof this.relationsMap[key]) {
                    case 'object':
                        this.relations[key] = new this.relationsMap[key][this.relations[key].meta.type](this.relations[key]);
                        break;
                    default:
                        this.relations[key] = new this.relationsMap[key](this.relations[key]);
                }
            }
        });
    }

    __casts() {
        Object.keys(this.casts).forEach((key) => {
            if(typeof this.data[key] === 'undefined') {
                this.data[key] = null;
                return;
            }

            if(this.data[key] !== null) {
                this.data[key] = new this.casts[key](this.data[key]);
            }
        });
    }

    get model() {
        return this.name ?? this.constructor.name.substring(0, this.constructor.name.length - 8); // Where -8 is "Resource"
    }

    get key() {
        return this.data.uuid ?? this.data.id;
    }

    toFormData(method) {
        let data = new FormData();

        data.set('_method', method ?? this.data.id ? 'patch' : 'put');

        _.each(this.data, (value, key) => {
            if(typeof value === 'string') {
                value = value.trim();
            }

            if(value === null) {
                value = '';
            }

            data.set(key, value);
        });

        return data;
    }
}

ConstraintResource.prototype.relationsMap = {};

/**
 * Storing it in the prototype due javascript is simply too dumb to handle inheritance properly.
 *
 * For a better solution, please pick up the contact with your local representatives and ask them to ban
 * javascript from the face of the earth. So then we can have a proper alternative in the future, probably.
 */
ConstraintResource.prototype.casts = {
    created_at: Date,
    updated_at: Date,
    deleted_at: Date,
};

